export default "__VITE_ASSET__ed37fc96__$_?nuxt_component=async__"